import React, { useEffect, useRef, useState } from 'react';
import Moment from 'react-moment';
import { dateString } from './Blog.utils';

export const PostPreview = ({ post, blogGroup = false }) => {
  const { title, imgSrc = null, imgAltText = null, body, blogGroupUrl, images } = post;
  const stringLength = 200;

  const date = dateString(post, '/');

  const bodyShort = blogGroup
    ? body
    : body.substring(
        0,
        stringLength + body.substring(stringLength).indexOf(' ')
      ) + '...';

  const hrefBase = `/blog/post/${blogGroupUrl}`;
  const href = `${hrefBase}${blogGroup ? '' : `/${dateString(post, '-')}`}`;

  // --- pick image (priority: new posts > legacy) ---
  let previewImgSrc = null;
  let previewImgAlt = imgAltText || title;

  if (images && images.length > 0) { //  
    const { year, month, day } = post;
    const postName = `${year}.${String(month).padStart(2, '0')}.${String(day).padStart(2, '0')}`;
    previewImgSrc = `/img/Blog/${postName}/${images[0].num}.jpeg`;
  } else if (imgSrc) {
    previewImgSrc = imgSrc;
  } 

  return (
    <a href={href} className='post-preview bg-dark grid'>
      {previewImgSrc && (
        <img className='col-xlg-2 col-lg-2' src={previewImgSrc} alt={previewImgAlt} />
      )}
      <div className='blog-header-container col-xlg-3 col-lg-3'>
        <h2
          className={`text-white small${blogGroup ? ' blog-group-header' : ''}`}
        >
          {title}
        </h2>
        {!blogGroup && (
          <p className='x-small text-primary'>
            <Moment format='MM/DD/YYYY'>{date}</Moment>
          </p>
        )}
      </div>
      <p
        className='blog-preview text-light x-small col-xlg-7 col-lg-7'
      >
        {bodyShort}
      </p>
    </a>
  );
};

// export const PostPage = ({ post }) => {
//   // const { title, instaCode, body, captionLineLengths, comment, portrait } =
//   const { title, body, instaCode } = post;

//   // can change this logic if ever needed-- setting it to 4 would do the single regression model rather than four scenario specific regression models
//   // const scenarioOverride = null;
//   return (
//     <>
//       <h1 className='large text-primary'>{title}</h1>
//       <p className='lead'>
//         <Moment format='MM/DD/YYYY'>{dateString(post, '/')}</Moment>
//       </p>
//       <div className='blog-body-container'>
//         <iframe
//           class='instagram-embed'
//           src={`https://www.instagram.com/p/${instaCode}/embed/captioned/`}
//           frameborder='0'
//           allowfullscreen
//         ></iframe>
//         {/* <Instapost instaCode={instaCode} /> */}
//         {/* <InstagramEmbed
//           instaCode={instaCode}
//           captionLineLengths={captionLineLengths}
//           comment={comment}
//           portrait={portrait}
//           scenarioOverride={scenarioOverride}
//         /> */}
//         <p className='blog-body'>{body}</p>
//       </div>
//     </>
//   );
// };

export const PostPage = ({ post }) => {
  const { title, body, instaCode, images } = post;

  return (
    <>
      <h1 className='large text-primary'>{title}</h1>
      <p className='lead'>
        <Moment format='MM/DD/YYYY'>{dateString(post, '/')}</Moment>
      </p>
      <div className='blog-body-container'>
        {images && images.length > 0 ? (
          <BlogImageCarousel post={post} />
        ) : (
          <iframe
            className='instagram-embed'
            src={`https://www.instagram.com/p/${instaCode}/embed/captioned/`}
            frameBorder='0'
            allowFullScreen
          ></iframe>
        )}
        <p className='blog-body'>{body}</p>
      </div>
    </>
  );
};

// export const BlogImageCarousel = ({ post }) => {
//   const { images } = post;
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [hovered, setHovered] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const containerRef = useRef(null);

//   // Detect mobile / desktop
//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 700);
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const { year, month, day } = post;
//   const postName = `${year}.${String(month).padStart(2, '0')}.${String(day).padStart(2, '0')}`;
//   const currentImage = images[currentIndex];
//   const src = `/img/Blog/${postName}/${currentImage.num}.jpeg`;

//   const goPrev = () => setCurrentIndex(prev => (prev === 0 ? images.length - 1 : prev - 1));
//   const goNext = () => setCurrentIndex(prev => (prev === images.length - 1 ? 0 : prev + 1));

//   return (
//     <div
//       ref={containerRef}
//       className="blog-img-carousel-container"
//       style={{
//         width: isMobile ? '100%' : '40%',
//         position: 'relative',
//         overflow: 'hidden',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//       }}
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//     >
//       {/* Image */}
//       <img
//         src={src}
//         alt={currentImage.caption || `Blog image ${currentIndex + 1}`}
//         style={{
//           width: '100%',
//           height: 'auto',
//           display: 'block',
//           borderRadius: 5,
//         }}
//       />

//       {/* Caption */}
//       {currentImage.caption && (
//         <div
//           className="text-container"
//           style={{
//             width: '100%',
//             textAlign: 'center',
//             marginTop: isMobile ? 8 : 4,
//             fontStyle: 'italic',
//           }}
//         >
//           <p>{currentImage.caption}</p>
//         </div>
//       )}

//       {/* Arrows */}
//       {hovered && (
//         <>
//           <div
//             onClick={goPrev}
//             style={{
//               position: 'absolute',
//               left: 0,
//               top: '50%',
//               transform: 'translateY(-50%)',
//               width: isMobile ? 40 : 60,
//               height: 'auto',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               cursor: 'pointer',
//               background: 'rgba(0,0,0,0.2)',
//               color: 'white',
//               fontSize: isMobile ? '1.5rem' : '2rem',
//             }}
//           >
//             ‹
//           </div>
//           <div
//             onClick={goNext}
//             style={{
//               position: 'absolute',
//               right: 0,
//               top: '50%',
//               transform: 'translateY(-50%)',
//               width: isMobile ? 40 : 60,
//               height: 'auto',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               cursor: 'pointer',
//               background: 'rgba(0,0,0,0.2)',
//               color: 'white',
//               fontSize: isMobile ? '1.5rem' : '2rem',
//             }}
//           >
//             ›
//           </div>
//         </>
//       )}
//     </div>
//   );
// };


export const BlogImageCarousel = ({ post }) => {
  const { images, year, month, day } = post;

  const postName = `${year}.${String(month).padStart(2, '0')}.${String(day).padStart(2, '0')}`;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [maxContainerHeight, setMaxContainerHeight] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const containerWidth = containerRef.current.offsetWidth;
    let tallest = 0;
    let processed = 0;

    images.forEach((img) => {
      const image = new Image();
      image.src = `/img/Blog/${postName}/${img.num}.jpeg`;
      image.onload = () => {
        const scaledHeight = (image.height / image.width) * containerWidth;
        const totalHeight = scaledHeight + 24 + 8; // caption + padding
        if (totalHeight > tallest) tallest = totalHeight;

        processed++;
        if (processed === images.length) {
          setMaxContainerHeight(tallest);
        }
      };
    });
  }, [images, postName]);

  const currentImage = images[currentIndex];
  const src = `/img/Blog/${postName}/${currentImage.num}.jpeg`;

  const goPrev = () => setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  const goNext = () => setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));

  return (
    <div
      className="blog-img-carousel-container"
      ref={containerRef}
      style={{
        position: 'relative',
        height: maxContainerHeight || 'auto',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          height: '100%',
        }}
      >
        <div
          className="image-wrapper"
          style={{
            position: 'relative',
            display: 'inline-block',
            width: '100%',
          }}
        >
          <img
            src={src}
            alt={currentImage.caption || `Blog image ${currentIndex + 1}`}
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
              borderRadius: 5,
              display: 'block',
            }}
          />

          {/* arrows bound to the image */}
          <button onClick={goPrev} className="carousel-arrow left-arrow">
            ‹
          </button>
          <button onClick={goNext} className="carousel-arrow right-arrow">
            ›
          </button>
        </div>

        {currentImage.caption && (
          <div
            className="text-container"
            style={{
              textAlign: 'center',
              marginTop: 8,
              fontStyle: 'italic',
              maxWidth: '90%',
            }}
          >
            <p>{currentImage.caption}</p>
          </div>
        )}
      </div>

      <style jsx>{`
        

        .carousel-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(0, 0, 0, 0.3);
          color: white;
          border: none;
          cursor: pointer;
          width: 60px;
          height: 80%;
          font-size: 2rem;
          opacity: 0;
          transition: opacity 0.3s;
        }
        .image-wrapper:hover .carousel-arrow {
          opacity: 1;
        }
        .left-arrow {
          left: 0;
        }
        .right-arrow {
          right: 0;
        }
      `}</style>
    </div>
  );
};